import { UserActions } from '@next/core-lib/user';
import { createReducer, on } from '@ngrx/store';

import { AttentionLimitsState } from '../../models/attention-limits.model';
import * as AttentionLimitsActions from '../actions/attention-limits.actions';

export const initialState: AttentionLimitsState = {
  attentionLimitsByDate: null,
  attentionLimits: null,
};

export const attentionLimitsReducer = createReducer<AttentionLimitsState>(
  initialState,
  on(AttentionLimitsActions.loadAttentionLimitsSuccess, (state, { attentionLimits }) => ({
    ...state,
    attentionLimits,
  })),
  on(
    AttentionLimitsActions.loadAttentionLimitsByDateSuccess,
    (state, { date, attentionLimits }) => ({
      ...state,
      attentionLimitsByDate: { date, attentionLimits },
    }),
  ),
  on(UserActions.relationshipSelected, () => initialState),
);
